export default __webpack_public_path__ + "static/media/favicon.51e96326.png";